import * as Yup from 'yup';

import { api_validate_signup_email_path } from '../../routes.js';
import request from '../../utils/backend-api/request';
import { FULL_NAME_REGEX } from '../../utils/constants';

interface ValidateEmailParams {
  email: string;
}

interface ValidateEmailResponse {
  success: boolean;
}

const validateEmail = async (params: ValidateEmailParams): Promise<ValidateEmailResponse> => {
  const response = await request('get', api_validate_signup_email_path(params));
  return response;
};

const validationSchema = () =>
  Yup.object().shape({
    email: Yup.string()
      .email('Please enter a valid email')
      .required('Email address is required')
      // Validate only if initial state of email is null
      .when('prefilledUserEmail', {
        is: (val) => val === null,
        then: Yup.string().test(
          'validate',
          'This email address already has an account',
          async (email) => {
            const { success } = await validateEmail({
              email,
            });

            return success;
          }
        ),
      }),
    name: Yup.string()
      .matches(FULL_NAME_REGEX, 'Please enter a full name with at least a first and last name')
      .required('Full name is required'),
  });

export default validationSchema;
